
    import './styles.scoped.css';
    export default {
  "root": "awsui_root_7nfqu_19e31_153",
  "has-adaptive-widths-default": "awsui_has-adaptive-widths-default_7nfqu_19e31_197",
  "has-adaptive-widths-dashboard": "awsui_has-adaptive-widths-dashboard_7nfqu_19e31_202",
  "drawer-expanded-mode": "awsui_drawer-expanded-mode_7nfqu_19e31_217",
  "navigation": "awsui_navigation_7nfqu_19e31_222",
  "tools": "awsui_tools_7nfqu_19e31_223",
  "global-tools": "awsui_global-tools_7nfqu_19e31_224",
  "tools-open": "awsui_tools-open_7nfqu_19e31_262",
  "split-panel-side": "awsui_split-panel-side_7nfqu_19e31_276",
  "split-panel-bottom": "awsui_split-panel-bottom_7nfqu_19e31_283",
  "panel-hidden": "awsui_panel-hidden_7nfqu_19e31_296",
  "toolbar-container": "awsui_toolbar-container_7nfqu_19e31_306",
  "notifications-container": "awsui_notifications-container_7nfqu_19e31_312",
  "notifications-background": "awsui_notifications-background_7nfqu_19e31_316",
  "main-landmark": "awsui_main-landmark_7nfqu_19e31_327",
  "main": "awsui_main_7nfqu_19e31_327",
  "main-disable-paddings": "awsui_main-disable-paddings_7nfqu_19e31_336",
  "content-header": "awsui_content-header_7nfqu_19e31_346",
  "content": "awsui_content_7nfqu_19e31_346",
  "unfocusable-mobile": "awsui_unfocusable-mobile_7nfqu_19e31_356",
  "hidden": "awsui_hidden_7nfqu_19e31_361"
};
  